import api from './client'

function encoded(value) {
  return encodeURIComponent(String(value))
}

export async function listTenantN8nWorkflows(tenantId, { signal } = {}) {
  const { data } = await api.get(
    `/admin/n8n/tenants/${encoded(tenantId)}/workflows`,
    { signal }
  )
  return data
}

export async function listAdminN8nTemplates({ signal } = {}) {
  const { data } = await api.get('/admin/n8n/templates', { signal })
  return data
}

export async function getAdminN8nWorkflow(workflowId, { signal } = {}) {
  const { data } = await api.get(
    `/admin/n8n/workflows/${encoded(workflowId)}`,
    { signal }
  )
  return data
}

export async function activateTenantN8nWorkflow(tenantId, workflowId) {
  const { data } = await api.post(
    `/admin/n8n/tenants/${encoded(tenantId)}/workflows/${encoded(workflowId)}/activate`
  )
  return data
}

export async function deactivateTenantN8nWorkflow(tenantId, workflowId) {
  const { data } = await api.post(
    `/admin/n8n/tenants/${encoded(tenantId)}/workflows/${encoded(workflowId)}/deactivate`
  )
  return data
}
